<app-page-breadcrumb [pageTitle]="isEditing ? 'Editar Segmento' : 'Nuevo Segmento'"></app-page-breadcrumb>

@if (isFormInvalidForSave && submitted) {
<div
    class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20 max-w-[1400px] mx-auto animate-fade-in">
    <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400 font-medium">{{ saveHint }}</p>
    </div>
</div>
}

<form [formGroup]="form" class="flex flex-col lg:flex-row gap-6 items-start max-w-[1400px] mx-auto pb-12">

    <!-- ── Left column: form content ── -->
    <div class="w-full lg:w-[65%] flex flex-col gap-6">

        <app-component-card title="Información del Segmento" desc="Complete los datos básicos del segmento">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 pt-4">

                <div>
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Nombre del Segmento <span class="text-error-500">*</span>
                    </label>
                    <input type="text" placeholder="Ej. Clientes VIP de Lima" formControlName="name"
                        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                        [class.border-error-500]="form.get('name')?.invalid && submitted"
                        [class.border-gray-300]="!(form.get('name')?.invalid && submitted)">

                    @if (form.get('name')?.invalid && submitted) {
                    <p class="mt-1.5 text-sm text-error-500">Este campo es requerido (mínimo 3 caracteres)</p>
                    }
                </div>

                <div>
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Carpeta
                    </label>
                    <select formControlName="folderId"
                        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 cursor-pointer">
                        <option value="">Ninguna (Sin carpeta)</option>
                        @for (folder of folders; track folder.id) {
                        <option [value]="folder.id">{{ folder.name }}</option>
                        }
                    </select>
                </div>

                <div class="md:col-span-2">
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Tipo de Segmento <span [class.text-error-500]="!isEditing">{{ isEditing ? '' : '*' }}</span>
                    </label>

                    @if (isEditing && currentSegmentType) {
                    <!-- Modo edición: tipo fijo, solo se cambia desde el botón "Convertir" -->
                    <div class="flex items-center gap-3 px-4 py-3 rounded-xl border"
                        [ngClass]="currentSegmentType === 'STATIC'
                            ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700'
                            : 'bg-brand-50/60 dark:bg-brand-900/10 border-brand-200 dark:border-brand-800'">
                        <div class="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center"
                            [ngClass]="currentSegmentType === 'STATIC'
                                ? 'bg-gray-100 dark:bg-gray-700'
                                : 'bg-brand-100 dark:bg-brand-900/30'">
                            @if (currentSegmentType === 'STATIC') {
                            <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                            </svg>
                            } @else {
                            <svg class="w-5 h-5 text-brand-500 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                            </svg>
                            }
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-semibold"
                                [ngClass]="currentSegmentType === 'STATIC'
                                    ? 'text-gray-800 dark:text-gray-200'
                                    : 'text-brand-700 dark:text-brand-300'">
                                {{ currentSegmentType === 'STATIC' ? 'Estático (Manual)' : 'Dinámico (Automático)' }}
                            </p>
                            <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
                                Para cambiar el tipo usa <span class="font-medium">Convertir</span> en el panel de Acciones
                            </p>
                        </div>
                        <span class="shrink-0 text-xs font-medium px-2.5 py-1 rounded-full"
                            [ngClass]="currentSegmentType === 'STATIC'
                                ? 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                                : 'bg-brand-100 dark:bg-brand-900/40 text-brand-600 dark:text-brand-400'">
                            {{ currentSegmentType === 'STATIC' ? 'ESTÁTICO' : 'DINÁMICO' }}
                        </span>
                    </div>
                    } @else {
                    <!-- Modo creación: selección libre del tipo -->
                    <div class="flex flex-col sm:flex-row gap-4">
                        <label
                            class="flex items-start gap-3 cursor-pointer p-4 border rounded-xl flex-1 bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700 hover:border-brand-300 transition-all duration-200 has-[:checked]:border-brand-500 has-[:checked]:bg-brand-50/50 dark:has-[:checked]:bg-brand-900/10 has-[:checked]:shadow-md group">
                            <input type="radio" name="type" value="STATIC" formControlName="type"
                                class="mt-0.5 w-4 h-4 text-brand-500 bg-gray-100 border-gray-300 focus:ring-brand-500 cursor-pointer">
                            <div>
                                <span
                                    class="block text-sm font-bold text-gray-900 dark:text-white group-has-[:checked]:text-brand-600 dark:group-has-[:checked]:text-brand-400">Estático
                                    (Manual)</span>
                                <span class="block text-sm text-gray-500 dark:text-gray-400 mt-1">Contactos fijos. Tú
                                    los agregas o quitas manualmente.</span>
                            </div>
                        </label>
                        <label
                            class="flex items-start gap-3 cursor-pointer p-4 border rounded-xl flex-1 bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700 hover:border-brand-300 transition-all duration-200 has-[:checked]:border-brand-500 has-[:checked]:bg-brand-50/50 dark:has-[:checked]:bg-brand-900/10 has-[:checked]:shadow-md group">
                            <input type="radio" name="type" value="DYNAMIC" formControlName="type"
                                class="mt-0.5 w-4 h-4 text-brand-500 bg-gray-100 border-gray-300 focus:ring-brand-500 cursor-pointer">
                            <div>
                                <span
                                    class="block text-sm font-bold text-gray-900 dark:text-white group-has-[:checked]:text-brand-600 dark:group-has-[:checked]:text-brand-400">Dinámico
                                    (Automático)</span>
                                <span class="block text-sm text-gray-500 dark:text-gray-400 mt-1">Se actualiza solo
                                    según las reglas de filtrado que definas.</span>
                            </div>
                        </label>
                    </div>
                    @if (form.get('type')?.invalid && submitted) {
                    <p class="mt-2 text-sm text-error-500 font-medium">Debe seleccionar el tipo de segmento para
                        continuar.</p>
                    }
                    }
                </div>

                <div class="md:col-span-2">
                    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Descripción <span class="text-gray-400 dark:text-gray-500 font-normal">(Opcional)</span>
                    </label>
                    <textarea rows="3" placeholder="Notas sobre el propósito de este segmento..."
                        formControlName="description"
                        class="w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-transparent px-4 py-3 text-sm text-gray-800 dark:text-white/90 placeholder:text-gray-400 dark:placeholder:text-white/30 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:bg-gray-900 dark:focus:border-brand-800 transition-all shadow-theme-xs"></textarea>
                </div>
            </div>
        </app-component-card>

        @if (!isLoadingSegment && form.get('type')?.value === 'STATIC') {
        <app-segment-filter-builder class="block w-full" [rules]="rules" [segmentType]="'STATIC'"
            [autoAddCondition]="false" [contactStates]="contactStates" [contactCycles]="contactCycles"
            [contactOrigins]="contactOrigins" [customAttributes]="customAttributes"
            [companySectors]="companySectors" [companySizes]="companySizes"
            [companyRelationshipTypes]="companyRelationshipTypes" [companyCycles]="companyCycles"
            [companyStateLeads]="companyStateLeads">
        </app-segment-filter-builder>

        <!-- Summary bar: change chips + "Ver Previsualización" button with embedded count -->
        <div class="flex items-center gap-2 flex-wrap">
            @if (isLoadingPreview) {
            <span class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                <span class="animate-spin rounded-full h-3 w-3 border-b border-current shrink-0"></span>
                Calculando...
            </span>
            } @else if (hasModifiedFilters && totalContactosPreview > 0) {
            <button type="button" (click)="openPreviewDrawer('match')"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border border-emerald-200 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 transition-colors">
                +{{ totalContactosPreview }} nuevos
            </button>
            }
            @if (isLoadingNoCoinciden) {
            <span class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                <span class="animate-spin rounded-full h-3 w-3 border-b border-current shrink-0"></span>
                Verificando...
            </span>
            } @else if (hasModifiedFilters && totalNoCoinciden > 0) {
            <button type="button" (click)="openPreviewDrawer('no-match')"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors">
                <svg class="w-3 h-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                </svg>
                {{ totalNoCoinciden }} no coinciden
            </button>
            }
            <button type="button" (click)="openPreviewDrawer('members')"
                class="ml-auto inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                @if (isEditing) {
                <span class="flex items-center gap-1 text-brand-600 dark:text-brand-400">
                    <span class="w-1.5 h-1.5 rounded-full bg-brand-500 dark:bg-brand-400 shrink-0"></span>
                    <span class="font-bold">{{ segmentMembersCount }}</span>
                </span>
                <span class="w-px h-3 bg-gray-300 dark:bg-gray-600 shrink-0"></span>
                }
                Ver Previsualización
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
            </button>
        </div>

        @if (isEditing && rules.length > 0 && hasModifiedFilters) {
        <div class="px-4 py-3 rounded-xl border flex items-center gap-3 text-sm transition-colors"
            [ngClass]="isLoadingPreview || isLoadingNoCoinciden
                ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400'
                : (totalContactosPreview > 0 || totalNoCoinciden > 0)
                    ? 'bg-brand-50 dark:bg-brand-900/10 border-brand-200 dark:border-brand-700 text-brand-700 dark:text-brand-300'
                    : 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400'">
            @if (isLoadingPreview || isLoadingNoCoinciden) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current shrink-0"></div>
                <span>Calculando cambios...</span>
            } @else if (totalContactosPreview > 0 || totalNoCoinciden > 0) {
                <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span>Al guardar:
                    @if (totalContactosPreview > 0) {
                        se añadirán <strong>{{ totalContactosPreview }} contacto{{ totalContactosPreview !== 1 ? 's' : '' }}</strong>
                    }
                    @if (totalContactosPreview > 0 && totalNoCoinciden > 0) { y }
                    @if (totalNoCoinciden > 0) {
                        se eliminarán <strong>{{ totalNoCoinciden }}</strong> que ya no coinciden con el filtro
                    }.
                </span>
            } @else {
                <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span>Ningún contacto nuevo cumple el filtro. Los miembros actuales se conservan.</span>
            }
        </div>
        }
        }

        @if (!isLoadingSegment && form.get('type')?.value === 'DYNAMIC') {
        @if (!showFilters && rules.length === 0) {
        <app-component-card title="Criterios de Segmentación"
            desc="Define qué contactos entrarán en esta lista automáticamente">
            <div class="flex flex-col items-center justify-center text-center py-10">
                <div
                    class="w-16 h-16 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mb-5 border border-gray-100 dark:border-gray-700">
                    <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
                        </path>
                    </svg>
                </div>
                <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">No has definido reglas</h3>
                <p class="text-sm text-gray-500 dark:text-gray-400 mb-6 max-w-md mx-auto">
                    Agrega filtros lógicos para que este segmento atrape y actualice contactos de forma automática.
                </p>
                <app-button type="button" (btnClick)="mostrarFiltros()">
                    Construir filtros
                </app-button>
            </div>
        </app-component-card>
        } @else {
        <app-segment-filter-builder class="block w-full" [rules]="rules" [segmentType]="'DYNAMIC'"
            [contactStates]="contactStates" [contactCycles]="contactCycles" [contactOrigins]="contactOrigins"
            [customAttributes]="customAttributes" [companySectors]="companySectors" [companySizes]="companySizes"
            [companyRelationshipTypes]="companyRelationshipTypes" [companyCycles]="companyCycles"
            [companyStateLeads]="companyStateLeads">
        </app-segment-filter-builder>

        <!-- Summary bar: preview count chip + "Ver Previsualización" button -->
        <div class="flex items-center gap-2 flex-wrap">
            @if (isLoadingPreview) {
            <span class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                <span class="animate-spin rounded-full h-3 w-3 border-b border-current shrink-0"></span>
                Calculando...
            </span>
            } @else if (totalContactosPreview > 0) {
            <button type="button" (click)="openPreviewDrawer('members')"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border border-emerald-200 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 transition-colors">
                +{{ totalContactosPreview }} coinciden
            </button>
            }
            <button type="button" (click)="openPreviewDrawer('members')"
                class="ml-auto inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                @if (isEditing) {
                <span class="flex items-center gap-1 text-brand-600 dark:text-brand-400">
                    <span class="w-1.5 h-1.5 rounded-full bg-brand-500 dark:bg-brand-400 shrink-0"></span>
                    <span class="font-bold">{{ segmentMembersCount }}</span>
                </span>
                <span class="w-px h-3 bg-gray-300 dark:bg-gray-600 shrink-0"></span>
                }
                Ver Previsualización
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
            </button>
        </div>
        }
        }

        <!-- SECCIÓN 4: FRECUENCIA DE ACTUALIZACIÓN (DINÁMICO) -->
        @if (form.get('type')?.value === 'DYNAMIC') {
        <div id="frecuencia-section">
        <app-component-card title="Frecuencia de Actualización"
            desc="¿Cada cuánto debe el sistema buscar y añadir nuevos contactos?">
            <div class="pt-4">
                <app-frequency-schedule
                    [form]="scheduleFormGroup"
                    [timezones]="timezones">
                </app-frequency-schedule>
            </div>
        </app-component-card>
        </div>
        }

        <div class="flex justify-end gap-3 pt-2">
            <app-button variant="outline" type="button" (btnClick)="cancelar()">
                Cancelar
            </app-button>
            @if (isSegmentEmpty) {
            <app-button variant="danger" type="button"
                [disabled]="isDeletingSegment"
                (btnClick)="eliminarSegmento()">
                @if (isDeletingSegment) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                Eliminando...
                } @else {
                Eliminar segmento
                }
            </app-button>
            } @else {
            <app-button type="button"
                [disabled]="isSaving || isFormInvalidForSave || !!staticPreview?.isLoadingMembers"
                (btnClick)="guardarSegmento()">
                @if (isSaving) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                Guardando...
                } @else {
                {{ isEditing ? 'Actualizar' : 'Guardar' }}
                }
            </app-button>
            }
        </div>

        @if (saveHint && !submitted) {
        <div class="flex items-start gap-2.5 px-3 py-2.5 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700">
            <svg class="w-4 h-4 text-amber-500 dark:text-amber-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            </svg>
            <p class="text-xs font-medium text-amber-700 dark:text-amber-300 leading-relaxed">{{ saveHint }}</p>
        </div>
        }

    </div>

    <!-- ── Right column: Acciones (edit mode only) ── -->
    @if (isEditing && currentSegmentType) {
    <div class="w-full lg:w-[35%] sticky top-20 flex flex-col gap-4">

        <!-- Previsualización shortcut -->
        <button type="button" (click)="openPreviewDrawer()"
            class="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 hover:border-brand-300 dark:hover:border-brand-700 hover:shadow-sm transition-all group">
            <div class="flex items-center gap-2.5">
                <div class="w-8 h-8 rounded-lg bg-brand-50 dark:bg-brand-900/20 flex items-center justify-center shrink-0">
                    <svg class="w-4 h-4 text-brand-500 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                </div>
                <div class="text-left">
                    <p class="text-sm font-semibold text-gray-800 dark:text-gray-100 group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors">Ver Previsualización</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                        <span class="font-bold text-brand-600 dark:text-brand-400">{{ segmentMembersCount }}</span> miembro{{ segmentMembersCount !== 1 ? 's' : '' }}
                        @if (hasModifiedFilters && totalContactosPreview > 0) {
                        · <span class="text-emerald-600 dark:text-emerald-400 font-bold">+{{ totalContactosPreview }}</span> nuevos
                        }
                        @if (hasModifiedFilters && totalNoCoinciden > 0) {
                        · <span class="text-amber-500 dark:text-amber-400 font-bold">{{ totalNoCoinciden }}</span> no coinciden
                        }
                    </p>
                </div>
            </div>
            <svg class="w-4 h-4 text-gray-400 group-hover:text-brand-500 dark:group-hover:text-brand-400 transition-colors shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
        </button>

        <!-- Acciones card -->
        <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl p-5 shadow-sm">
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">Acciones</h3>
            <div class="flex flex-col gap-2">

                <button type="button" (click)="cambiarTipoSegmento()" [disabled]="isChangingType || isLoadingPreview || isLoadingNoCoinciden"
                    class="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium border transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    [ngClass]="currentSegmentType === 'STATIC'
                        ? 'border-brand-200 dark:border-brand-700 text-brand-600 dark:text-brand-400 bg-brand-50 dark:bg-brand-900/20 hover:bg-brand-100 dark:hover:bg-brand-900/30'
                        : 'border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700'">
                    @if (isChangingType) {
                        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
                    } @else {
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
                        </svg>
                    }
                    {{ currentSegmentType === 'STATIC' ? 'Convertir a Dinámico' : 'Convertir a Estático' }}
                </button>

                @if (currentSegmentType === 'DYNAMIC') {
                <button type="button" (click)="irAFrecuencia()"
                    class="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    Evaluación Programada
                </button>
                }

                @if (currentSegmentType === 'STATIC') {
                <button type="button" (click)="abrirOperaciones()"
                    class="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                    </svg>
                    Operaciones de Conjuntos
                </button>
                }

                @if (currentSegmentType === 'STATIC') {
                <app-segment-import-section [segmentId]="segmentId!" (imported)="onImportCompleted()" />
                }

            </div>
        </div>

    </div>
    }

    <!-- ── Drawer: @if removes element from DOM when closed, bypassing overflow-x-hidden containing-block trap ── -->
    @if (showPreviewDrawer) {

    <!-- Backdrop -->
    <div class="fixed inset-0 bg-black/40 z-drawer" (click)="closePreviewDrawer()"></div>

    <!-- Drawer panel -->
    <aside
        class="fixed top-0 right-0 z-drawer h-full flex flex-col w-[540px] max-w-[95vw] bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-800 shadow-2xl overflow-hidden"
        [class.drawer-slide-in]="!isDrawerClosing"
        [class.drawer-slide-out]="isDrawerClosing">

        <!-- Drawer header -->
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-800 shrink-0">
            <div class="min-w-0">
                <h2 class="text-sm font-bold text-gray-900 dark:text-white">Contactos del segmento</h2>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate">{{ form.get('name')?.value || 'Sin nombre' }}</p>
            </div>
            <button type="button" (click)="closePreviewDrawer()"
                class="ml-3 shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>

        <!-- Tab bar: STATIC editing with modified filters → 3 tabs -->
        @if (form.get('type')?.value === 'STATIC' && isEditing && hasModifiedFilters) {
        <div class="flex border-b border-gray-200 dark:border-gray-800 shrink-0">
            <button type="button" (click)="previewDrawerTab = 'members'"
                class="flex-1 py-2.5 px-2 text-xs font-semibold transition-colors relative"
                [ngClass]="previewDrawerTab === 'members'
                    ? 'text-brand-600 dark:text-brand-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">
                Miembros
                <span class="ml-1 text-[10px] font-bold bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 px-1.5 py-0.5 rounded">{{ segmentMembersCount }}</span>
                @if (previewDrawerTab === 'members') {
                <span class="absolute bottom-0 inset-x-0 h-0.5 bg-brand-500 rounded-t"></span>
                }
            </button>
            <button type="button" (click)="previewDrawerTab = 'match'"
                class="flex-1 py-2.5 px-2 text-xs font-semibold transition-colors relative"
                [ngClass]="previewDrawerTab === 'match'
                    ? 'text-emerald-600 dark:text-emerald-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">
                @if (isLoadingPreview) {
                <span class="inline-block w-2.5 h-2.5 rounded-full border-b border-current animate-spin mr-1 align-middle"></span>
                } @else if (totalContactosPreview > 0) {
                <span class="mr-1 text-[10px] font-bold bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 px-1.5 py-0.5 rounded">+{{ totalContactosPreview }}</span>
                }
                Coinciden
                @if (previewDrawerTab === 'match') {
                <span class="absolute bottom-0 inset-x-0 h-0.5 bg-emerald-500 rounded-t"></span>
                }
            </button>
            <button type="button" (click)="previewDrawerTab = 'no-match'"
                class="flex-1 py-2.5 px-2 text-xs font-semibold transition-colors relative"
                [ngClass]="previewDrawerTab === 'no-match'
                    ? 'text-amber-600 dark:text-amber-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">
                @if (isLoadingNoCoinciden) {
                <span class="inline-block w-2.5 h-2.5 rounded-full border-b border-current animate-spin mr-1 align-middle"></span>
                } @else if (totalNoCoinciden > 0) {
                <span class="mr-1 text-[10px] font-bold bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 px-1.5 py-0.5 rounded">{{ totalNoCoinciden }}</span>
                }
                No coinciden
                @if (previewDrawerTab === 'no-match') {
                <span class="absolute bottom-0 inset-x-0 h-0.5 bg-amber-500 rounded-t"></span>
                }
            </button>
        </div>

        <!-- Tab bar: STATIC editing without modified filters → single Miembros tab -->
        } @else if (form.get('type')?.value === 'STATIC' && isEditing) {
        <div class="flex border-b border-gray-200 dark:border-gray-800 shrink-0">
            <button type="button"
                class="flex-1 py-2.5 px-2 text-xs font-semibold text-brand-600 dark:text-brand-400 relative cursor-default">
                Miembros
                <span class="ml-1 text-[10px] font-bold bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 px-1.5 py-0.5 rounded">{{ segmentMembersCount }}</span>
                <span class="absolute bottom-0 inset-x-0 h-0.5 bg-brand-500 rounded-t"></span>
            </button>
        </div>
        }

        <!-- Drawer content -->
        <div class="flex-1 overflow-y-auto p-5">
            @if (form.get('type')?.value === 'STATIC') {
            <app-segment-static-preview
                [drawerTab]="previewDrawerTab"
                [segmentId]="segmentId"
                [isEditing]="isEditing"
                [rulesLength]="rules.length"
                [contactosPreview]="contactosPreview"
                [totalContactosPreview]="totalContactosPreview"
                [porcentajePreview]="porcentajePreview"
                [totalContactosCrm]="totalContactosCrm"
                [isLoadingPreview]="isLoadingPreview"
                [previewPage]="previewPage"
                [previewTotalPages]="previewTotalPages"
                [contactosAExcluirIds]="contactosAExcluirIds"
                [filtersModified]="hasModifiedFilters"
                [contactosNoCoinciden]="contactosNoCoinciden"
                [totalNoCoinciden]="totalNoCoinciden"
                [isLoadingNoCoinciden]="isLoadingNoCoinciden"
                [noCoincidentPage]="noCoincidentPage"
                [noCoincidentTotalPages]="noCoincidentTotalPages"
                (pageChange)="cargarPreview($event)"
                (noCoincidentPageChange)="cargarNoCoinciden($event)"
                (excludeToggle)="toggleExcluirContacto($event)"
                (segmentGone)="onSegmentGone()"
                (memberCountChange)="onMemberCountChange($event)">
            </app-segment-static-preview>
            } @else {
            <app-segment-preview-panel
                [type]="form.get('type')?.value"
                [hasRules]="rules.length > 0"
                [showFilters]="showFilters"
                [isLoadingPreview]="isLoadingPreview"
                [totalContactosPreview]="totalContactosPreview"
                [porcentajePreview]="porcentajePreview"
                [totalContactosCrm]="totalContactosCrm"
                [contactosPreview]="contactosPreview"
                [previewPage]="previewPage"
                [previewTotalPages]="previewTotalPages"
                (pageChange)="cargarPreview($event)">
            </app-segment-preview-panel>
            }
        </div>
    </aside>

    } <!-- /@if showPreviewDrawer -->

</form>
